// external imports
import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useDispatch } from 'react-redux';

// internal imports
import { deleteSite as deletingSite } from 'actions';

const DeleteSiteModal = ({
	isOpen,
	toggleDelete,
	deleteSite,
	setDeleteSite
}) => {
	const dispatch = useDispatch();

	const onDeleteAction = async (site) => {
		dispatch(deletingSite({ id: site.id }));
		setDeleteSite(null);
		toggleDelete(null);
	};

	return (
		<Modal isOpen={isOpen} toggle={toggleDelete}>
			<ModalHeader toggle={toggleDelete}>
				<i className="fas fa-trash-alt mr-3" />
				Delete a site
			</ModalHeader>
			<ModalBody>
				<p>
					Please confirm that you really want to delete site '{deleteSite?.name}
					'?
				</p>
				<p className="small text-muted">
					Deleting a site will remove associated group relationships in the
					database too, which include Captures, PseudoGroup relationships,
					Updates and UserSmelter sign-ups. A deleted site nor the data from
					these relationships can be recovered.
				</p>
				<p className="small text-danger">PROCEED WITH CAUTION!</p>
			</ModalBody>
			<ModalFooter>
				<Button
					color="info"
					size="sm"
					onClick={() => onDeleteAction(deleteSite)}
				>
					Delete site
				</Button>{' '}
				<Button color="secondary" size="sm" onClick={toggleDelete}>
					Cancel
				</Button>
			</ModalFooter>
		</Modal>
	);
};

export default DeleteSiteModal;
